<template>
  <path d="M26,9H24.4V21a.8.8,0,1,1-1.6,0H22v3.2h1.6A3.2,3.2,0,0,0,26.8,21V9.8A.8.8,0,0,0,26,9Z" transform="translate(-3.8 -1.4)"/><path d="M18.2,2H3.8a.8.8,0,0,0-.8.8V19.6a3.2,3.2,0,0,0,3.2,3.2H19V2.8A.8.8,0,0,0,18.2,2Zm-8,16.8H5.4V17.2h4.8Zm0-3.2H5.4V14h4.8Zm0-3.2H5.4V10.8h4.8Zm6.4,6.4H11.8V17.2h4.8Zm0-3.2H11.8V14h4.8Zm0-3.2H11.8V10.8h4.8Zm0-7.2V7.6H5.4V5.2Z"/>
</template>
